import { useState, useCallback, useEffect } from 'react';
export var useHeadingEditing = function useHeadingEditing(_ref) {
  var heading = _ref.heading,
      headingLabel = _ref.headingLabel,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      onUpdateHeading = _ref.onUpdateHeading;

  var _useState = useState(null),
      editingField = _useState[0],
      setEditingField = _useState[1];

  var _useState2 = useState(false),
      descriptionHovered = _useState2[0],
      setDescriptionHovered = _useState2[1];

  var _useState3 = useState((heading === null || heading === void 0 ? void 0 : heading.title) || ''),
      localTitle = _useState3[0],
      setLocalTitle = _useState3[1];

  var _useState4 = useState((heading === null || heading === void 0 ? void 0 : heading.description) || ''),
      localDescription = _useState4[0],
      setLocalDescription = _useState4[1]; // Initialize local values when heading changes


  useEffect(function () {
    setLocalTitle((heading === null || heading === void 0 ? void 0 : heading.title) || '');
    setLocalDescription((heading === null || heading === void 0 ? void 0 : heading.description) || '');
  }, [heading === null || heading === void 0 ? void 0 : heading.title, heading === null || heading === void 0 ? void 0 : heading.description]);
  var handleTitleFocus = useCallback(function () {
    if (readonly) return;
    var defaultTitleText = "".concat((headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.defaultHeadingTitle) || '');

    if (localTitle === defaultTitleText) {
      setLocalTitle('');
    }

    setEditingField('title');
  }, [readonly, localTitle, headingLabel]);
  var handleTitleBlur = useCallback(function () {
    if (readonly) return;
    var defaultTitleText = "".concat((headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.defaultHeadingTitle) || '');

    if (!localTitle.length) {
      setLocalTitle(defaultTitleText);
      onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('title', defaultTitleText);
    } else {
      onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('title', localTitle);
    }

    setEditingField(null);
  }, [readonly, localTitle, headingLabel, onUpdateHeading]);
  var handleTitleKeyDown = useCallback(function (e) {
    if (readonly) return;

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      var defaultTitleText = "".concat((headingLabel === null || headingLabel === void 0 ? void 0 : headingLabel.defaultHeadingTitle) || '');

      if (!localTitle.length) {
        setLocalTitle(defaultTitleText);
        onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('title', defaultTitleText);
      } else {
        onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('title', localTitle);
      }

      setEditingField(null);
      e.currentTarget.blur();
    }
  }, [readonly, localTitle, headingLabel, onUpdateHeading]);
  var handleTitleChange = useCallback(function (e) {
    setLocalTitle(e.target.value);
  }, []);
  var handleDescriptionClick = useCallback(function () {
    if (readonly) return;
    setEditingField('description');
  }, [readonly]);
  var handleDescriptionSave = useCallback(function () {
    if (readonly) return;
    onUpdateHeading === null || onUpdateHeading === void 0 ? void 0 : onUpdateHeading('description', localDescription);
    setEditingField(null);
  }, [readonly, localDescription, onUpdateHeading]);
  var handleDescriptionCancel = useCallback(function () {
    if (readonly) return;
    setLocalDescription((heading === null || heading === void 0 ? void 0 : heading.description) || '');
    setEditingField(null);
  }, [readonly, heading]);
  var handleDescriptionChange = useCallback(function (value) {
    setLocalDescription(value);
  }, []);
  return {
    editingField: editingField,
    descriptionHovered: descriptionHovered,
    localTitle: localTitle,
    localDescription: localDescription,
    setDescriptionHovered: setDescriptionHovered,
    handleTitleFocus: handleTitleFocus,
    handleTitleBlur: handleTitleBlur,
    handleTitleChange: handleTitleChange,
    handleTitleKeyDown: handleTitleKeyDown,
    handleDescriptionClick: handleDescriptionClick,
    handleDescriptionSave: handleDescriptionSave,
    handleDescriptionCancel: handleDescriptionCancel,
    handleDescriptionChange: handleDescriptionChange,
    isTitleEditing: editingField === 'title',
    isDescriptionEditing: editingField === 'description'
  };
};